/**
 * 此文件c端接口的使用,是有供销关系的情况下使用供货商的线框图
 */

import { lhCustomerClient } from "../index";
import { Brand } from "../brand";
import { CaseMaterial } from "../material";
import { PhoneModel } from "../model";

/**
 * 查找手机品牌信息
 */
export async function getBrandList(sellerUsername: string): Promise<Brand[]> {
    return lhCustomerClient.get("/customer/cell_phone/brand/list", { sellerUsername });
}

export interface getModelListParams {
    pageNo: number;
    pageSize: number;
    sellerUsername: string;
    modelName?: string;
    brandId?: number;
    modelId?: number;
}

/**
 * 查找手机型号
 */
export async function getModelList(params: getModelListParams): Promise<{ models: PhoneModel[]; total: number }> {
    return lhCustomerClient.get("/customer/cell_phone/model/list", params);
}

/**
 * 查找手机型号
 */
export async function getModelByIds(params: { sellerUsername: string; ids: number[] }): Promise<PhoneModel[]> {
    return lhCustomerClient.post("/customer/cell_phone/model/batchGet", params);
}

/**
 * 查询所有材质信息
 */
export async function getCaseMaterialList(sellerUsername: string): Promise<CaseMaterial[]> {
    return lhCustomerClient.get("/customer/cell_phone/case_material/list_all", {
        sellerUsername,
    });
}

interface HasConfigRecordParams {
    sellerUsername: string;

    caseMaterialId: number;

    brandId?: number;

    modelId?: number;

    enabled?: boolean;
}

/**
 * 根据手机品牌,型号,材质id其中一个判断是否存在材质配置
 */
export async function existsConfigRecord(params: HasConfigRecordParams): Promise<boolean> {
    const bol = await lhCustomerClient.get("/customer/cell_phone/case_material/record/exists", params);

    return bol === true;
}
